import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasVisibleChars',
  standalone: true,
})
export class HasVisibleCharsPipe implements PipeTransform {
  transform(htmlString?: string): boolean {
    if (!htmlString) {
      return false;
    }
    const stripped = htmlString.replace(/<[^>]*>/g, '').trim();
    return stripped.length > 0;
  }
}
